import React, { useEffect, useState, Suspense, lazy } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./OliveShell.scss";
import "./Login.scss";
import { LoginModel } from "../../../models/LoginModel";
import { login } from "../../../services/users/users.service";

const Loader = lazy(() => import("../Loader/index"));

interface LoginProps {
  onLogin: (status: boolean) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const ref = queryParams.get("ref");

  useEffect(() => {
    setIsLoading(true);
    const userCredentials: LoginModel = {
      grantType: "form",
      refreshToken: "",
      reference: ref != null ? ref : "",
    };

    login(userCredentials).then((response) => {
      if (response === "success") {
        onLogin(true);
        navigate("/", { replace: true });
      } else {
        setIsLoading(false);
      }
    });
  }, [ref, navigate, onLogin]);

  return <Suspense fallback={<Loader isLoading={isLoading} />}></Suspense>;
};

export default Login;
